// @flow

import * as Immutable from 'immutable';
import PropTypes      from 'prop-types';


export type TaxonomyKeys =
  | '@id'
  | '@type'
  | 'id'
  | 'namePlural'
  | 'nameSingular'
  | 'slug'
  | 'key'
  | 'isHierarchical';

export type Taxonomy = Immutable.Map<TaxonomyKeys, *>;


const taxonomyShape = {
  '@id':          PropTypes.string.isRequired,
  '@type':        PropTypes.string.isRequired,
  id:             PropTypes.string.isRequired,
  namePlural:     PropTypes.string.isRequired,
  nameSingular:   PropTypes.string.isRequired,
  slug:           PropTypes.string.isRequired,
  key:            PropTypes.string.isRequired,
  isHierarchical: PropTypes.string,
};


const taxonomyPropType = PropTypes.shape(taxonomyShape);


export {
  taxonomyShape,
  taxonomyPropType,
};



// WEBPACK FOOTER //
// ./src/domain/taxonomy.js